import urlParser from "js-video-url-parser";
import React from "react";
const IframePlayer = ({ isCustomVideo, url }) => {
  const embedUrl = isCustomVideo ? url : urlParser.create({
    videoInfo: urlParser.parse(url),
    format: "embed"
  });
  return /* @__PURE__ */ React.createElement(
    "iframe",
    {
      "data-hook": "video-ssr-viewer",
      title: "ricos-video",
      style: { width: "100%" },
      allow: "fullscreen",
      src: embedUrl,
      allowFullScreen: true,
      loading: "lazy"
    }
  );
};
var IframePlayer_default = IframePlayer;
export {
  IframePlayer_default as default
};
//# sourceMappingURL=IframePlayer.js.map
